var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{class:['languages-select', 'user-languages-select ' + _vm.classList],attrs:{"options":_vm.options,"options-label":"name","options-value":"code","name":"languages[]","search":_vm.search,"multiple":"","placeholder":_vm.placeholder ? _vm.placeholder : 'Editor Languages',"disabled":_vm.isDisabled},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-332fc57b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generic/SelectLanguages.vue
// module id = 997
// module chunks = 6